import { render, staticRenderFns } from "./StoryReviewEdit.vue?vue&type=template&id=2261b8b6&scoped=true"
import script from "./StoryReviewEdit.vue?vue&type=script&lang=js"
export * from "./StoryReviewEdit.vue?vue&type=script&lang=js"
import style0 from "./StoryReviewEdit.vue?vue&type=style&index=0&id=2261b8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2261b8b6",
  null
  
)

export default component.exports